import { render, staticRenderFns } from "./ModuleTitleCell.vue?vue&type=template&id=877be8be&scoped=true"
import script from "./ModuleTitleCell.vue?vue&type=script&lang=js"
export * from "./ModuleTitleCell.vue?vue&type=script&lang=js"
import style0 from "./ModuleTitleCell.vue?vue&type=style&index=0&id=877be8be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877be8be",
  null
  
)

export default component.exports